import prop from 'lodash/fp/prop'
import { synapse } from 'state'
import { BASE_URL } from 'config'

export async function fetchDocuments(wtID, body) {
  const fetchParams = body ? [{ method: 'POST' }, body] : []

  const documents = await synapse
    .fetch(`${BASE_URL}/workingtables/${wtID}/documents`, ...fetchParams)
    .catch(console.error)

  if (!documents || !documents.body) {
    console.error(`Couldn't get documents for working table ${wtID}`)
    return { items: [], metadata: {} }
  }

  if (!documents.body.items) {
    const length = documents.body.length
    return {
      items: documents.body,
      metadata: {
        pagination: {
          start: 0,
          length: length,
          total: length
        }
      }
    }
  }

  return documents.body
}

export const getDocuments = () => {} // TODO: delete
export const getPaginatedDocuments = fetchDocuments

export function getDocumentOptionsForFilter(wtID, { field }) {
  try {
    return synapse.fetch(`${BASE_URL}/workingtables/${wtID}/documents/${field}`)
  } catch (err) {
    console.error(err)
    return { body: [] }
  }
}

export function getDetailDocumentOptionsForFilter(
  wtID,
  { detailField, documentId, field }
) {
  try {
    return synapse.fetch(
      `${BASE_URL}/workingtables/${wtID}/documents/${documentId}/${detailField}/${field}`
    )
  } catch (err) {
    console.error(err)
    return { body: [] }
  }
}

export function removePaginatedDocuments(wtID, type, body) {
  return synapse.fetch(
    `${BASE_URL}/workingtables/${wtID}/documents/${type}`,
    { method: 'DELETE' },
    body
  )
}

export function duplicateDocuments(wtID, body) {
  return synapse.fetch(
    `${BASE_URL}/workingtables/duplicateDocs/${wtID}`,
    { method: 'POST' },
    body
  )
}

export function getPaginatedDocumentDetails(
  wtId,
  documentId,
  detailField,
  requestBody
) {
  return synapse
    .fetch(
      `${BASE_URL}/workingtables/${wtId}/documents/${documentId}/${detailField}`,
      { method: 'POST' },
      requestBody
    )
    .then(prop('body'))
}

export const documentWizardSave = async ({ activityId, body }) => {
  return await synapse
    .fetch(
      `${BASE_URL}/workingtables/${activityId}/fill`,
      { method: 'POST' },
      { body: body }
    )
    .catch((error) => {
      console.error(error)
      return {}
    })
    .then((res) => {
      return res?.body
    })
}

export const documentWizardUpdate = async ({ activityId, body }) => {
  return await synapse
    .fetch(
      `${BASE_URL}/workingtables/${activityId}/update`,
      { method: 'PUT' },
      { body: body }
    )
    .catch((error) => {
      console.error(error)
      return {}
    })
    .then((res) => {
      return res?.body
    })
}
